import { CHECKLIST_ITEM_KEY } from '../shared/constants';
export const NO_SUBTYPE = '';
export function toDraftRows(rows) {
    return rows.map((row, index) => {
        var _a;
        return ({
            key: `existing-${index}`,
            isNew: false,
            ipType: row.ipSystemDeviceType,
            ipSubtype: (_a = row.ipSystemDevice) !== null && _a !== void 0 ? _a : NO_SUBTYPE,
            stId: row.stEquipmentTypeId,
            stName: row.stEquipmentType
        });
    });
}
export function toMapRows(rows) {
    return rows.map((row) => ({
        ipSystemDeviceType: row.ipType,
        ipSystemDevice: row.ipSubtype === NO_SUBTYPE ? null : row.ipSubtype,
        stEquipmentTypeId: row.stId,
        stEquipmentType: row.stName
    }));
}
export function catalogFrom(verification) {
    var _a, _b, _c;
    const item = (_a = verification.checklist) === null || _a === void 0 ? void 0 : _a.items.find((entry) => entry.key === CHECKLIST_ITEM_KEY.EQUIPMENT_TYPES);
    return (_c = (_b = item === null || item === void 0 ? void 0 : item.equipmentTypes) === null || _b === void 0 ? void 0 : _b.catalog) !== null && _c !== void 0 ? _c : null;
}
export function isComplete(row) {
    return row.ipType !== '' && row.stId !== '';
}
export function hasDuplicate(rows) {
    const keys = rows.map((row) => `${row.ipType}|${row.ipSubtype}`);
    return new Set(keys).size !== keys.length;
}
